var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "blocker-wrapper" }, [
    _c("div", { staticClass: "overlay" }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "blocker-inner" },
      [
        _c("i", { staticClass: "fa fa-lock" }),
        _vm._v(" "),
        _c("h2", [_vm._v(_vm._s(_vm.$t("global.isBlocked2.title")))]),
        _vm._v(" "),
        _c(
          "p",
          {
            domProps: {
              innerHTML: _vm._s(_vm.$t("global.isBlocked2.content")),
            },
          },
          [
            _vm._v(
              "\n            Votre compte est vérouillé et nécessite une action administrative pour être actif à nouveau.\n            "
            ),
            _c("br"),
            _c("br"),
            _vm._v(
              "\n            Veuillez prendre contact avec le service administratif Beepiz (+33247411010).\n        "
            ),
          ]
        ),
        _vm._v(" "),
        _c("br"),
        _c("br"),
        _vm._v(" "),
        _c(
          "Btn",
          {
            class: "primary reverse",
            nativeOn: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.onLogoutHandler($event)
              },
            },
          },
          [
            _vm._v(
              "\n                " +
                _vm._s(_vm.$t("nav.logout")) +
                "\n            "
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }